import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import Send from './components/Send';
import Success from './components/Success';
import { Router, Route, browserHistory } from 'react-router';
import './css/index.css';
import 'react-mdl/extra/material.css';
import 'react-mdl/extra/material.js';
// import 'dialog-polyfill/dialog-polyfill.css';
// import 'dialog-polyfill/dialog-polyfill.js';

ReactDOM.render((
  <Router history={browserHistory}>
    <Route path="/" component={App}>
      <Route path="success" component={Success}/>
      <Route path="send" component={Send}/>
      {/*<Route path="*" component={NoMatch}/>*/}
    </Route>
  </Router>
), document.getElementById('root'))



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/